import { render, staticRenderFns } from "./BusinessContactForm.vue?vue&type=template&id=1cd03ab0"
import script from "./BusinessContactForm.vue?vue&type=script&lang=js"
export * from "./BusinessContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports